class PlannedTime {
    id = "";


    customId = "";

    /**
     * @type {Date}
     */
    start;

    /**
     * @type {Date}
     */
    end;

    title = "";

    hourlyRate = 0;

    /**
     * @type {Customer}
     */
    customer;

    constructor(data={}) {
        Object.assign(this, data);
    }
}
export default PlannedTime;